module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Chart-line1-665e136d58cd1fbdf1b78e4a594d71e6.svg";